
export default {
    'demo':"这是个demo哦",
    'Send':'发送',
    'Search':'搜索',
    'Submit':'提交',
    'Success':'成功',
    'Expand':'展开',
    'Fold':'收起',
    'Confirm':'确认',
    'Processing':'处理中',
    'ok':'确定',
    'all':'全部',
    'nCol':'{num, plural, =1 {一} =2 {两} =3 {三} other {#}}列',
    'chronological':'流程',
    'all-in-one':'拼图',
    'mine':'我的',
    'hide':'隐藏',
    'show':'显示',
    'cancel':'取消',
    'loading':'加载中',
    'tip':'提示',
    'long-press-to-save':'长按即可保存此图片',
    'long-press-to-save-1':'图片长按保存',
    'time':'时间',
    'place':'地点',
    'slide-up':'上滑翻页',
    'wrong-pass':'抱歉，您输入的密码有误！请核对！',
    'speaker-guest':'嘉宾介绍',
    'live-photo':'照片即享',
    'live-video':'视频即享',
    'fast-editing':'视频拍摄及快剪',
    'details':'活动详情',
    'agenda':'活动流程',
    'organizer':'主办方',
    'Introduction':'活动介绍',
    'Time':'活动时间',
    'Place':'活动地点',
    'Recently-visited':'最近访问',
    'Go':'进入',
    'History album':'历史相册',
    'Album':'我的相册',
    'Like':'我的喜欢',
    'all-in-one-image':'我的拼图',
    'Click to view':'进入相册',
    'Confirm deletion':'真的不要我了？',
    'Album-OK':'真的',
    'Album-Cancel':'我再想想',
    'Back':'返回',
    'Loaded':'大图已加载',
    //预约部分
    'Phone-Is-required':'联系电话为必填项',
    'Name-Is-required':'联系姓名为必填项',
    'City-Is-required':'活动地点为必填项',
    'Date-Is-required':'活动日期为必填项',
    'PreOrder-Name':'请输入您的姓名',
    'PreOrder-Phone':'请输入您的手机号',
    'PreOrder-City':'请选择',
    'PreOrder-Start':'拍摄开始时间',
    'PreOrder-End':'拍摄结束时间',
    'PreOrder-Main':'即刻预约 开启无限惊喜',
    'PreOrder-Hotline':'预约电话',
    'PreOrder-Tip':'请保持手机畅通，我们将尽快与您联系',
    'Please select service type':'请选择服务类型',
    'Date not right':'结束日期不得早于开始日期',
    'Order fails':'预约失败，请致电人工客服',
    //大图
    'Full image':'查看大图',
    'BigPic-Likes':'{num, plural, =0{喜欢} other {# 人喜欢}}',
    //代码中的字符串
    'Not Started':'活动开始前',
    'Ascending':'升序',
    'Descending':'降序',
    'Order received':'预约成功',
    'MAX_JIGSAW_NUM':'目前最多只能拼接{num}张图片',
    'min-jigsaw':'至少需要{num}张才能进行拼图',
    'Collaging':'拼图生成中...',
    'No more photos':'已经到底了',
    'photo update':'已更新{num}张照片',
    'share-default':'即享照片直播，让每一个被分享的瞬间足够精彩',
    //我的影集相关
    'my-album':'我的影集',
    'in-album':'进入影集',
    'Modify':'修改',
    'Delete':'删除',
    'photo':'照片',
    'photos':'张',
    'photos2':'张照片',
    'album':'相册',
    'all album':'历史相册',
    'current album':'当前相册',
    'My friends':'我的好友',
    'Add friends':'添加好友',
    'album-tip':'小贴士',
    'album-tip-content':'为识别准确，用户上传的大头照片，',
    //注意，由于一些展示上的原因，这里要分成2行，而英文实际上用一行
    'album-tip-content2':'务必是正面清晰、无遮挡无美颜的单人照片',
    'Delete friend':'确定删除好友？',
    'Max friend number':'好友人数已达6人',
    'Max friend number2':'需删除才能添加',
    'Name placeholder':'请输入好友名字',
    'Name is required':'请输入名字',
    '+friends':'+ 好友',
    'Know him/her':'你认识TA吗?',
    'No photos':'暂无照片',
    'HideAvatar':'人脸识别',
    'ShowAvatar':'显示人脸',
    'Wrong recognition':'识别有误',
    'Deleting operation is beyond retrieve':'隐藏不可还原',
    'Please upload single frontal photo':'请上传正面照片，人脸尽量充满相框',
    'after upload':'请上传正面照片，人脸尽量充满相框，上传后不能修改',
    'Changing frontal photo is not available now':'暂不支持修改正面照片',
    'Upload and agree':'上传并同意',
    'Jfoto service agreement':'即享服务使用协议',
    'for better service':'以便为你更好的提供服务',
    'Please read and agree to the agreement firstly':'请先阅读并同意协议',
    'no sb':'这张照片没有{name}？',
    'Deleting is beyond retrieve':'删除不可恢复',
    'photo of x':'{name}的照片',
    'detail avatar tip':'点击头像，可查看TA在当前相册的所有照片',
    'Guide':'使用指南',
    'click the wrong recognition button':'为提高识别数量，可能会出现个别错误照片，点击下方图片，找到“识别有误”按钮即可删除',
    'How to find images quickly?':'如何快速找照片？',
    'Intelligent face recognition':'智能人脸识别',
    'Click the portrait on bottom of photo page to review all photos of him/her in this album, also to add as friend.':
        '点击照片页底部头像，可查看该人在本场活动的全部照片，还可一键添加好友。',
     'Friends\' automatic recognition':'好友自动识别',
    'Click "Find" button, add friend\'s portrait to review all photos of this friend in this album. When you switch to new album, it will do automatic recognition. There is no need to reupload the portrait.':
        '点击“找人”按钮，添加好友头像，可查看当前相册中全部好友照片。切换新相册自动识别，无需每次重复上传头像。',
    'Cross albums\' self-recognition':'本人跨相册识别',
    'Click "Find" button, upload your portrait, to review all your photos in your visited historical albums.':'点击“找人”按钮，上传自己头像，可查看访问过的全部即享相册中的自己照片。',

    //评论相关
    'Comment':'发表评论',
    'All comments':'全部评论',
    'My comments':'我的评论',
    'Content':'内容',
    'Please input the comment':'请输入评论内容',
    'Comment should not be longer than 140 letters':'评论不得长于140字',
    'Bullet screen':'弹幕',
    'No comments':'占个沙发，说两句吧',

    //弹幕
    'DanmakuOn':'弹',
    'DanmakuOff':'弹',
    'Say something':'快来说出你的感想吧',

    //视频
    'Back Home':'返回首页',

    //号码牌
    'Enter your participate no., letters included':'请输入参赛号码，如有字母也请输入',


};



// WEBPACK FOOTER //
// ./src/locale/zh_CN.js